import * as checked from '../../lib/checked';
export const ColorItem = checked.record({
  label: checked.string().optional(),
  key: checked.string(),
  value: checked.string() // hex color string
}, 'ColorItem');
export const InterpolateColorItem = checked.record({
  positionFraction: checked.number(),
  // any number in range [0, 1]
  value: checked.string() // hex color string
}, 'InterpolateColorItem');
export const SchemeTypes = {
  DISCRETE: 'DISCRETE',
  INTERPOLATE: 'INTERPOLATE',
  DISCRETE_PATTERN: 'DISCRETE PATTERN',
  BRAND_KIT: 'BRAND KIT'
};
export const SchemeType = checked.symbol(SchemeTypes, 'SchemeTypes');
export const DiscreteScheme = checked.record({
  type: SchemeType.always(SchemeTypes.DISCRETE).defaultValue(SchemeTypes.DISCRETE),
  colors: checked.list(ColorItem)
});
export const BrandKitScheme = checked.record({
  type: SchemeType.always(SchemeTypes.BRAND_KIT).defaultValue(SchemeTypes.BRAND_KIT),
  colors: checked.list(ColorItem)
});
export const InterpolateScheme = checked.record({
  type: SchemeType.always(SchemeTypes.INTERPOLATE).defaultValue(SchemeTypes.INTERPOLATE),
  points: checked.list(InterpolateColorItem)
});
export const DiscretePatternScheme = checked.record({
  type: SchemeType.always(SchemeTypes.DISCRETE_PATTERN).defaultValue(SchemeTypes.DISCRETE_PATTERN),
  colors: checked.list(ColorItem),
  patterns: checked.list(checked.string()),
  dashStylePatterns: checked.list(checked.string())
});
export const Scheme = checked.poly('type', {
  [SchemeTypes.DISCRETE]: DiscreteScheme,
  [SchemeTypes.INTERPOLATE]: InterpolateScheme,
  [SchemeTypes.DISCRETE_PATTERN]: DiscretePatternScheme,
  [SchemeTypes.BRAND_KIT]: BrandKitScheme
}, 'Scheme');
export const BRAND_KIT_PALETTE_ID = 'BrandKit';
export const PaletteIds = {
  Categorical14: 'Categorical14',
  PatternFill14: 'PatternFill14',
  ShadesOfOrange: 'ShadesOfOrange',
  ShadesOfAqua: 'ShadesOfAqua',
  ShadesOfPurple: 'ShadesOfPurple',
  ShadesOfYellow: 'ShadesOfYellow',
  ShadesOfPink: 'ShadesOfPink',
  ShadesOfBlue: 'ShadesOfBlue',
  ShadesOfGreen: 'ShadesOfGreen',
  TokyoFive: 'TokyoFive',
  BogotaFive: 'BogotaFive',
  DublinFive: 'DublinFive',
  CambridgeFive: 'CambridgeFive',
  SingaporeFive: 'SingaporeFive',
  SydneyFive: 'SydneyFive',
  BerlinFive: 'BerlinFive',
  ParisFive: 'ParisFive',
  SanFranciscoFive: 'SanFranciscoFive',
  PortsmouthFive: 'PortsmouthFive',
  GhentFive: 'GhentFive',
  OceanFive: 'OceanFive',
  SpringFive: 'SpringFive',
  CherryBlossomFive: 'CherryBlossomFive',
  PastelFive: 'PastelFive',
  DefaultY2: 'DefaultY2',
  AlertRedToGreen: 'AlertRedToGreen',
  AlertGreenToRed: 'AlertGreenToRed',
  BrandKit: BRAND_KIT_PALETTE_ID
};
export const checkedPaletteIds = checked.symbol(PaletteIds, 'PaletteIds');
export const Palette = checked.record({
  id: checked.symbol(PaletteIds, 'PaletteIds'),
  label: checked.string(),
  i18nLabel: checked.string().optional(),
  scheme: Scheme
}, 'Palette');